import React, { useRef } from 'react'
import { useInfiniteHits, UseInfiniteHitsProps } from "react-instantsearch";
import { LeumitDoctor } from "assets/constants";
import { BaseHit, Hit } from "instantsearch.js";
import { LeumitDoctorType, MashlimDoctorType } from "types";
import { MashlimDoctorResult } from "./mashlimDoctorResult/MashlimDoctorResult"
import LeumitDoctorResult from "./leumitDoctorResult/LeumitDoctorResult";
import strings from 'assets/strings';


export default function GeoInfiniteHitsComponent(props: UseInfiniteHitsProps) {
  const { hits, showMore, isLastPage  } = useInfiniteHits(props);
  //const [nextFocusIndex, setCurrentFocusIndex] = React.useState(0);
  const doctorResultRef = useRef<HTMLDivElement>(null);

  const handleShowMore = () => {
    showMore();
    //setCurrentFocusIndex(nextFocusIndex + 20);
    doctorResultRef.current?.focus();
  }

  //const showDistance = new URLSearchParams(window.location.search).has("loc");

  
  return (
    <div className="animate">
      {hits.map((hit: Hit<BaseHit>, index) => {
        //const meters = (hit as any)?._rankingInfo?.geoDistance;
        //const km =typeof meters === "number" ? (meters / 1000).toFixed(1) : null;

        return (
          <div key={`${hit.objectID}_${index}`} className="hitWithDistance">
            {/* {showDistance && km && (
              <div className="distanceText">{km} ק״מ</div>
            )} */}

            {hit.type === LeumitDoctor ? (
              <LeumitDoctorResult
                hit={hit as LeumitDoctorType}
                ref={doctorResultRef}
              />
            ) : (
              <MashlimDoctorResult hit={hit as MashlimDoctorType} />
            )}
          </div>
        );
      })}

      {!isLastPage && (
        <button
          className="ais-InfiniteHits-loadMore"
          onClick={handleShowMore}
          disabled={isLastPage}
        >
          {strings.globalStrings.moreResults}
        </button>
      )}
    </div>
  );
}
